import type { Attachment } from '../state/store.js';
import type { WsAttachment } from '../ws/types.js';

/**
 * Le serveur renvoie des URL racine-relatives (`/api/attachments/...`) : le
 * widget tourne sur bokame.com et l'API sur chat.bokame.com, donc on
 * préfixe ici. Volontairement côté client plutôt qu'une variable
 * d'environnement « URL publique » de plus côté serveur.
 */
export function toAbsoluteUrl(backendUrl: string, url: string): string {
  return url.startsWith('/') ? `${backendUrl}${url}` : url;
}

/**
 * Convertit les pièces jointes telles que renvoyées par le serveur (WS ou
 * REST) en `Attachment[]` prêtes pour le store. Fonction pure partagée entre
 * `App.tsx#handleIncoming` (réception WS) et `App.tsx#resyncHistory`
 * (rattrapage REST) — avant le correctif D16, seul le chemin WS appelait ce
 * mapping : la resync REST reconstruisait les messages sans `attachments`,
 * et comme elle écrase l'entrée existante dans `mergeHistory` (fusion par
 * id), un message photo déjà reçu perdait ses pièces jointes dès la
 * prochaine resync (rebranchement WS, retour au premier plan…) — c'est
 * cette version appauvrie qui finissait par être persistée dans
 * localStorage, d'où les images manquantes au rechargement.
 */
export function mapAttachments(
  backendUrl: string,
  list: WsAttachment[] | undefined,
): Attachment[] | undefined {
  if (!list || list.length === 0) return undefined;
  return list.map((a) => ({ ...a, url: toAbsoluteUrl(backendUrl, a.url) }));
}
